/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Hamburger/theme';

export const HamburgerTheme = theme;
